import axiosInstance from './../axiosInstance';

/**
 * Send support email
 *
 * @param {int} contactID
 * @param {object} values
 */
export const sendSupportEmail = (eventID, partnerID, payload) => {
  return axiosInstance.post(`events/${eventID}/partners/${partnerID}/sendSupportEmail`, payload);
};
